import React from 'react'

import Section from './editable/Section'

import Product from '../Product'
import AddArticle from '../AddArticle';

import ArticleItem from '../common/ArticleItem';

import Backend from '../../utils/Backend'

import Titles from './editable/Titles';

import Block from "./Block";


export default class Block43 extends Block {
  constructor(props){
    super(props)

    this.state = {
      data: props.data,
      editable: props.editable,
      loading: true,
      articles: []
    }

  }

  componentDidMount(){
    Backend.getArticles()
    .then(articles => {
      this.setState({ articles, loading: false })
    })
    .catch(error => {
      this.setState({ loading: false })
    })
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _update(data, callback){
    this.setState({ data }, () => {

      if(callback){
        callback()
      }
      this.updateContentBlock()
    })
  }

  _renderArticlesLoading(){
    return (
      <>
        <Product/>
        <Product/>
        <Product/>
      </>
    )
  }

  _renderArticles(data, articles){
    let {
      loading
    } = this.state

    if(loading){
      return this._renderArticlesLoading()
    }

    return articles.map((article, index) => {
      return (
        <ArticleItem article={article}/>
      )
    })
  }

  _renderContent(){
    let {
      data,
      editable,
      articles,
      loading
    } = this.state

    if(!loading && articles.length == 0){
      return <AddArticle/>
    }

    return (
      <>
        <Titles
            data={ data }
            editable={ editable }
            onUpdated={data => this._update(data)}
            rowCssClasses={"dc-mb-1"}
            alignment={"text-left"}
            headingNumber={3}
          />
        <div className="row dc-row-v3">
            { this._renderArticles(data, articles) }
        </div>
      </>
    )

  }

  render(){
    let {
      data,
      editable,
      articles,
      loading
    } = this.state

    if(!loading && !editable && articles.length === 0){
      return null
    }

    let blockClassName = " block-18 block-43 bg--secondary  ";
    if (window.IS_CARD_STYLE_WEBSITE) {
      blockClassName += " deep-cardify";
    }

    return (
      <Section
          data={ data }
          index={ this.props.index }
          className={ blockClassName + this.props.className }
          editable={ editable }
          onUpdated={data => this._update(data)}
          onDelete={() => this.props.onDelete()}
          primaryColor={false}
          secondaryColor={false}
          onAddContentBlockPressed={contentBlock => this.props.onAddContentBlockPressed(contentBlock)}
          canMoveUp={ this.props.canMoveUp }
          canMoveDown={ this.props.canMoveDown }
          onVisibilityButtonPressed={(index) => this.props.onVisibilityButtonPressed(index)}
          onMoveUpPressed={ () => this.props.onMoveUpPressed() }
          onMoveDownPressed={ () => this.props.onMoveDownPressed() }
          onVisibilityToggled={() => this.props.onVisibilityToggled()}
      >
          <div className="container">
              { this._renderContent() }
          </div>
      </Section>
    )
  }
}
